(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired115"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired115"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jrCsX", function(module, exports) {

$parcel$export(module.exports, "initialize_select2", function () { return $e27e6083f8ee1b57$export$efc38d65eafcd66e; });
function $e27e6083f8ee1b57$export$efc38d65eafcd66e(root = document) {
    var _window_rebredgVendors, _$_fn;
    const $ = (_window_rebredgVendors = window.rebredgVendors) === null || _window_rebredgVendors === void 0 ? void 0 : _window_rebredgVendors.select2Jquery;
    if (!($ === null || $ === void 0 ? void 0 : (_$_fn = $.fn) === null || _$_fn === void 0 ? void 0 : _$_fn.select2)) return;
    root.querySelectorAll('.rebredg-cf7-form select').forEach((select)=>{
        var _placeholderOption_textContent;
        if (select.dataset.select2Initialized === 'true') return;
        const field = select.closest('.rebredg-form-field') || select.parentElement;
        const placeholderOption = [
            ...select.options
        ].find((option)=>!option.value || option.value === '0');
        $(select).select2({
            width: '100%',
            placeholder: select.dataset.placeholder || (placeholderOption === null || placeholderOption === void 0 ? void 0 : (_placeholderOption_textContent = placeholderOption.textContent) === null || _placeholderOption_textContent === void 0 ? void 0 : _placeholderOption_textContent.trim()) || '',
            closeOnSelect: !select.multiple,
            dropdownParent: field ? $(field) : undefined,
            minimumResultsForSearch: select.multiple ? Infinity : 8
        });
        const updateMultipleState = ()=>{
            if (!select.multiple || !field) return;
            const values = $(select).val();
            const hasSelection = Array.isArray(values) ? values.length > 0 : Boolean(values);
            field.classList.toggle('has-selection', hasSelection);
            const inlineSearch = field.querySelector('.select2-search--inline');
            if (inlineSearch) inlineSearch.remove();
            const selection = field.querySelector('.select2-selection--multiple');
            if (selection) {
                selection.setAttribute('tabindex', '0');
                selection.setAttribute('aria-label', field.dataset.label || select.getAttribute('aria-label') || 'Choose options');
            }
        };
        if (select.multiple && field) {
            updateMultipleState();
            $(select).on('select2:open', ()=>{
                field.classList.add('is-active');
                window.requestAnimationFrame(()=>{
                    var _field_querySelector;
                    (_field_querySelector = field.querySelector('.select2-search--inline')) === null || _field_querySelector === void 0 ? void 0 : _field_querySelector.remove();
                });
            }).on('select2:close', ()=>{
                field.classList.remove('is-active');
            }).on('select2:select select2:unselect change', updateMultipleState);
            field.addEventListener('keydown', (event)=>{
                var _event_target_closest, _event_target;
                const selection = (_event_target_closest = (_event_target = event.target).closest) === null || _event_target_closest === void 0 ? void 0 : _event_target_closest.call(_event_target, '.select2-selection--multiple');
                if (!selection) return;
                if ([
                    'Enter',
                    ' ',
                    'ArrowDown'
                ].includes(event.key)) {
                    event.preventDefault();
                    $(select).select2('open');
                }
                if (event.key === 'Escape') $(select).select2('close');
            });
        }
        const syncSelect2 = ()=>{
            $(select).trigger('change.select2');
            updateMultipleState();
        };
        const observer = new MutationObserver(syncSelect2);
        observer.observe(select, {
            attributes: true,
            attributeFilter: [
                'disabled',
                'aria-busy'
            ],
            childList: true,
            subtree: true
        });
        select.dataset.select2Initialized = 'true';
    });
}

});

parcelRegister("1TayK", function(module, exports) {

$parcel$export(module.exports, "initialize_cf7_success_view", function () { return $16031e6575d154e8$export$ab25eff31cb77213; });
function $16031e6575d154e8$export$ab25eff31cb77213(block, options = {}) {
    if (!block || block.dataset.cf7SuccessInitialized === 'true') return;
    const { defaultSelector: defaultSelector = '[data-cf7-success-default]', successSelector: successSelector = '[data-cf7-success]', headingSelector: headingSelector = '[data-cf7-success-heading]', stateDataKey: stateDataKey = 'cf7State' } = options;
    const defaultViews = Array.from(block.querySelectorAll(defaultSelector));
    const successView = block.querySelector(successSelector);
    if (!successView) return;
    const successHeading = successView.querySelector(headingSelector);
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    block.addEventListener('wpcf7mailsent', (event)=>{
        if (!(event.target instanceof Element) || !block.contains(event.target)) return;
        defaultViews.forEach((view)=>{
            view.hidden = true;
        });
        successView.hidden = false;
        block.classList.add('is-submitted');
        block.dataset[stateDataKey] = 'success';
        const blockTop = block.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
            top: blockTop,
            behavior: reducedMotion ? 'auto' : 'smooth'
        });
        window.setTimeout(()=>{
            successHeading === null || successHeading === void 0 ? void 0 : successHeading.focus({
                preventScroll: true
            });
        }, reducedMotion ? 0 : 550);
    });
    block.dataset.cf7SuccessInitialized = 'true';
}

});



var $jrCsX = parcelRequire("jrCsX");

var $1TayK = parcelRequire("1TayK");
function $217596a65aad8ba5$export$7e08bb921349ce7e(root = document) {
    root.querySelectorAll('[data-component="contact-us-page"]').forEach((block)=>{
        if (block.dataset.contactUsInitialized === 'true') return;
        (0, $jrCsX.initialize_select2)(block);
        (0, $1TayK.initialize_cf7_success_view)(block, {
            defaultSelector: '[data-contact-default]',
            successSelector: '[data-contact-thank-you]',
            headingSelector: '[data-contact-thank-you-heading]',
            stateDataKey: 'contactState'
        });
        block.dataset.contactUsInitialized = 'true';
    });
}


const $86eb23924f11488c$var$runBlock = ()=>(0, $217596a65aad8ba5$export$7e08bb921349ce7e)(document);
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', $86eb23924f11488c$var$runBlock, {
    once: true
});
else $86eb23924f11488c$var$runBlock();

})();
//# sourceMappingURL=contact-us-page.js.map
